import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=1a795ff4&scoped=true"
import script from "./servers.vue?vue&type=script&lang=js"
export * from "./servers.vue?vue&type=script&lang=js"
import style0 from "./servers.vue?vue&type=style&index=0&id=1a795ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a795ff4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
